var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualMskCareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8f3f7;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#58b7c0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 40,
    height: 40,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.59,12.34c0-1.29-1.05-2.34-2.34-2.34s-2.34,1.05-2.34,2.34,1.05,2.34,2.34,2.34,2.34-1.05,2.34-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.41,28.83h-.73s.02-.07.03-.1c.27-.93-.27-1.91-1.21-2.17-1.38-.39-2.68-1.11-3.75-2.08-.35-.32-.57-.76-.58-1.2-.02-.75-.22-1.39-.57-1.9-.25-.36-.6-.67-1.04-.92-.39-.23-.68-.63-.78-1.11-.08-.36-.13-.74-.17-1.14h5.23c.97,0,1.76-.79,1.76-1.76s-.79-1.76-1.76-1.76h-14.1c-.97,0-1.76.79-1.76,1.76s.79,1.76,1.76,1.76h5.35c.08,1.13.31,2.24.68,3.32l-3.25,1.63c-.6.3-.97.9-.97,1.57v3.52c0,.21.04.4.1.59h-3.07c-.32,0-.59.26-.59.59s.26.59.59.59h18.83c.32,0,.59-.26.59-.59s-.26-.59-.59-.59ZM25.86,15.86c.32,0,.59.26.59.59s-.26.59-.59.59h-5.27v-.59c0-.21-.04-.4-.1-.59h5.37ZM15.9,25.45v2.79c0,.32-.26.59-.59.59s-.59-.26-.59-.59v-3.52c0-.22.12-.42.32-.52l3.16-1.58c.16.36.33.71.52,1.05l-2.51,1.26c-.2.1-.32.3-.32.52ZM16.97,28.83c.07-.18.1-.38.1-.59v-2.43l2.28-1.14c1.15,1.7,2.68,3.13,4.53,4.15h-6.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualMskCareIcon);
export default __webpack_public_path__ + "static/media/Virtual MSK Care Icon.f920d0a53d033586e5202dec40e75b97.svg";
export { ForwardRef as ReactComponent };